import { PLATFORMS, CURRENT_PLATFORM } from './constants';

const { name: CURRENT_PLATFORM_NAME } = CURRENT_PLATFORM;

/**
 * Whether a platform match an other or not.
 * Use the current platform name as default platform to match.
 *
 * @param {string} platformToTest
 * @param {string} [platformToMatch = CURRENT_PLATFORM_NAME]
 * @returns {boolean}
 */
export function isPlatform(
  platformToTest,
  platformToMatch = CURRENT_PLATFORM_NAME,
) {
  return platformToTest === platformToMatch;
}

/**
 * Whether a platform is the french one or not.
 * Use the current platform name as default platform to match.
 *
 * @param {string} [platformToMatch = CURRENT_PLATFORM_NAME]
 * @returns {boolean}
 */
export function isFrenchPlatform(platformToMatch = CURRENT_PLATFORM_NAME) {
  return isPlatform(PLATFORMS.FRENCH, platformToMatch);
}

/**
 * Whether a platform is the britannic one or not.
 * Use the current platform name as default platform to match.
 *
 * @param {string} [platformToMatch = CURRENT_PLATFORM_NAME]
 * @returns {boolean}
 */
export function isBritishPlatform(platformToMatch = CURRENT_PLATFORM_NAME) {
  return isPlatform(PLATFORMS.BRITANNIC, platformToMatch);
}

/**
 * Whether a platform is the german one or not.
 * Use the current platform name as default platform to match.
 *
 * @param {string} [platformToMatch = CURRENT_PLATFORM_NAME]
 * @returns {boolean}
 */
export function isGermanPlatform(platformToMatch = CURRENT_PLATFORM_NAME) {
  return isPlatform(PLATFORMS.GERMAN, platformToMatch);
}

/**
 * Whether a platform is the spanish one or not.
 * Use the current platform name as default platform to match.
 *
 * @param {string} [platformToMatch = CURRENT_PLATFORM_NAME]
 * @returns {boolean}
 */
export function isSpanishPlatform(platformToMatch = CURRENT_PLATFORM_NAME) {
  return isPlatform(PLATFORMS.SPANISH, platformToMatch);
}

/**
 * Whether a platform is the italian one or not.
 * Use the current platform name as default platform to match.
 *
 * @param {string} [platformToMatch = CURRENT_PLATFORM_NAME]
 * @returns {boolean}
 */
export function isItalianPlatform(platformToMatch = CURRENT_PLATFORM_NAME) {
  return isPlatform(PLATFORMS.ITALIAN, platformToMatch);
}
